import { render, staticRenderFns } from "./details-right.vue?vue&type=template&id=6a836014&scoped=true&"
import script from "./details-right.vue?vue&type=script&lang=ts&"
export * from "./details-right.vue?vue&type=script&lang=ts&"
import style0 from "./details-right.vue?vue&type=style&index=0&id=6a836014&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a836014",
  null
  
)

export default component.exports